import { initials } from "../../lib/format";
import { cn } from "../../lib/cn";

const SIZES = {
  xs: "w-6 h-6 text-[10px]",
  sm: "w-7 h-7 text-xs",
  md: "w-9 h-9 text-sm",
  lg: "w-12 h-12 text-base",
} as const;

export function Avatar({
  name = "?",
  url,
  size = "md",
  className,
}: {
  name?: string;
  url?: string | null;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        className={cn(
          "inline-block rounded-full object-cover",
          "ring-1 ring-white/15 shadow-glass-sm",
          SIZES[size],
          className
        )}
      />
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full font-semibold",
        "bg-gradient-to-br from-brand-400 to-brand-700 text-white",
        "ring-1 ring-white/15 shadow-glass-sm select-none",
        SIZES[size],
        className,
      )}
      title={name}
    >
      {initials(name)}
    </span>
  );
}
